const BASE_URL = process.env.REACT_APP_BASE_URL;

export const signDocument = async (token,  pdfFile, requestJson) => {
    const url = `${BASE_URL}/signature/pdf?idpid=tsp`;

    const formData = new FormData();
    formData.append('content', pdfFile, 'tosign.pdf');
    formData.append('request', new Blob([JSON.stringify(requestJson)], { type: 'application/json' }), 'request.json');
    const response = await fetch(url, {
        method: 'POST',
        headers: {
            'Authorization': `Bearer ${token}`
        },
        body: formData
    });

    if (!response.ok) {
        throw new Error('Failed to sign document');
    }

    return await response.blob();
};
